import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton, MatIconButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import { ResponseRequestModel } from '../../../../core/models/response.model'
import { MatInputModule } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { MatIcon } from '@angular/material/icon'
import { DocumentTypeService } from '../../../../core/services/document/document-type/document-type.service'

@Component({
  selector: 'driver-upload-insert-form',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatOption,
    MatSelect,
    MatIcon,
    MatIconButton,
  ],
  templateUrl: './driver-upload-insert-form.component.html',
  styleUrl: './driver-upload-insert-form.component.scss',
  providers: [DocumentTypeService],
  standalone: true,
})
export class DriverUploadInsertFormComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
    private documentTypeService: DocumentTypeService,
  ) {}

  form: FormGroup = new FormGroup({})
  loading = false

  @Output() response = new EventEmitter()
  @Input() editItem: any = {}

  listType: any[] = []
  file: File | null = null
  allowedTypes = []

  ngOnInit(): void {
    this.getListType()
    this.createForm()
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }

  private treatmentItem() {
    if (this.checkEdit()) {
      this.form.reset()
      this.fillForm()
    }
  }

  getListType() {
    this.documentTypeService.listDocumentType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listType = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  checkEdit() {
    if (this.editItem) {
      if (this.editItem.idCreate) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  fillForm() {
    this.file = this.editItem.Arquivo
    this.form.get('description')?.setValue(this.editItem.Descricao)
    this.form.get('typeDocument')?.setValue(this.editItem.TipoDocId)
    if (this.file) {
      this.form.get('file')?.setValue(this.file.name)
    } else {
      this.form.get('file')?.setValue('')
    }
  }

  resetForm() {
    this.form.reset()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      description: ['', [Validators.required]],
      typeDocument: ['', [Validators.required]],
      file: ['', [Validators.required]],
    })
  }

  getTypeDescription() {
    const typeId = this.form.get('typeDocument')?.value
    if (typeId) {
      const element = this.listType.find((ele: any) => {
        return ele.id === typeId
      })
      return element.descricao
    } else {
      return ''
    }
  }

  createFile() {
    this.loading = true
    const model = this.createModel()
    this.response.emit({ action: 'create', item: model })
    this.resetForm()
    this.loading = false
  }

  editFile() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'edit', item: model })
    this.resetForm()
    this.loading = false
  }

  deleteContact() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'delete', item: model })
    this.resetForm()
    this.loading = false
  }

  cancel() {
    this.response.emit({ action: 'cancel' })
    this.resetForm()
    this.file = null
  }

  createModel(edit = false) {
    if (edit) {
      return {
        idCreate: this.editItem.idCreate,
        Descricao: this.form.controls['description'].value,
        TipoDocId: this.form.controls['typeDocument'].value,
        TipoDoc: this.getTypeDescription(),
        Arquivo: this.file,
      }
    } else {
      return {
        Descricao: this.form.controls['description'].value,
        TipoDocId: this.form.controls['typeDocument'].value,
        TipoDoc: this.getTypeDescription(),
        Arquivo: this.file,
      }
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement
    if (input.files && input.files.length > 0) {
      this.file = input.files[0]
      this.form.get('file')?.setValue(this.file.name)
    }
  }
  getAllowedTypes() {
    return this.allowedTypes.map((item) => `.${item}`).join(', ')
  }
}
